<template>
    <div class="tabbar-content rd-mobile-tabs">
        <MobileTabs v-if="isMobileHome" :active="actIdx" @select="change" />
        <div v-else class="tabbar">
            <div v-if="isShowSport" class="item" :class="{ 'act': actIdx == 2 }" @click.stop="toSports">
                <!-- <van-icon name="apps-o" /> -->
                <img class="imgAct" :src="$themeImage('tabbar.sport')" alt="">
                <img :src="$themeImage('tabbar.sport')" alt="">
                <div class="item-text">{{ $t("tabbar.sport") }}</div>
            </div>
            <div v-if="!isShowSport" class="item" :class="{ 'act': actIdx == 2 }" @click.stop="change(2)">
                <!-- <van-icon name="apps-o" /> -->
                <img class="imgAct" src="@/assets/mobile-home/ui/menu-active.svg" alt="">
                <img src="@/assets/mobile-home/ui/menu.svg" alt="">
                <div class="item-text">{{ $t("tabbar.menu") }}</div>
            </div>
            <div class="item" :class="{ 'act': actIdx == 1 }" @click.stop="change(1)">
                <!-- <van-icon name="wap-home-o" /> -->
                <img class="imgAct" src="@/assets/mobile-home/ui/casino-active.svg" alt="">
                <img src="@/assets/mobile-home/ui/casino.svg" alt="">
                <div class="item-text">{{ $t("tabbar.Lobby") }}</div>
            </div>
            <div class="item" :class="{ 'act': actIdx == 3 }" @click.stop="change(3)">
                <!-- <van-icon name="friends-o" /> -->
                <img class="imgAct" src="@/assets/mobile-home/ui/affiliate-active.svg" alt="">
                <img src="@/assets/mobile-home/ui/affiliate.svg" alt="">
                <div class="item-text">{{ $t("tabbar.Affiliate") }}</div>
            </div>
            <div class="item" :class="{ 'act': actIdx == 4 }" @click.stop="change(4)">
                <!-- <van-icon name="diamond-o" /> -->
                <AccountIcon v-if="['Person', 'vip'].includes($route.name)" name="crown" class="pcn-tab-crown" />
                <template v-else><img class="imgAct" src="@/assets/mobile-home/ui/vip-active.svg" alt=""><img src="@/assets/mobile-home/ui/vip.svg" alt=""></template>
                <div class="item-text">VIP</div>
            </div>
            <div class="item" :class="{ 'act': actIdx == 5 }" @click.stop="change(5)">
                <!-- <van-icon name="contact-o" /> -->
                <img class="imgAct" src="@/assets/mobile-home/ui/account-active.svg" alt="">
                <img src="@/assets/mobile-home/ui/account.svg" alt="">
                <div class="item-text">{{ $t("tabbar.Account") }}</div>
            </div>
        </div>
        <!-- <div v-if="isShowSaveVersion" class="pwa" @click="onShowSaveVersionPopup">
            <div class="iconfont icon-jiahao"></div>
            <div class="txt">{{ $t('downApp.SaveVersionDesktop') }}</div>
            <div class="iconfont icon-s-cuowu-guanbi" @click.stop="onCloseSaveVersion"></div>
        </div> -->
        <pwaIosPopup ref="pwaIosPopup" :isToHome="false"></pwaIosPopup>
        <SaveVersionPopup ref="SaveVersionPopup" :isToHome="false"></SaveVersionPopup>
        <div v-if="!isMobileHome" class="legacy-tabbar-spacer" style="height: 1.24rem"></div>
    </div>
</template>

<script>
import pwaIosPopup from '@/views/downAppPWA/modules/pwaIosPopup'
import SaveVersionPopup from '@/views/downAppPWA/modules/SaveVersionPopup'
import { isPWA, getPlatform } from '@/utils'
import MobileTabs from '@/components/mobile-home/MobileTabs.vue'
import AccountIcon from '@/views/person/components/accountIcon.vue'
export default {
    name: 'Tabbar',
    components: { pwaIosPopup, SaveVersionPopup, MobileTabs, AccountIcon },
    data() {
        return {
            actIdx: 1,
            isSaveVersionDesktop: true
        }
    },
    computed: {
        isMobileHome() { return this.$store.state.app.device === 'mobile' && this.$route.path.toLowerCase() === '/home' },
        isShowSport() {
            const msg = this.$store.state.system.betSportMsg
            return msg?.brandId !== null && msg?.gameInfoId !== null
        },
        isShowSaveVersion() {
            return this.$store.state.system.isSaveVersionDesktop === 1 && this.isSaveVersionDesktop && (!isPWA()) && getPlatform() !== 'android' && getPlatform() !== 'Android'
        }
    },
    created() {
        this.syncActiveTab(this.$route.path)
    },
    watch: {
        $route: {
            handler: function (to, from) {
                this.syncActiveTab(this.$route.path)
            },
            deep: true
        }
    },
    methods: {
        syncActiveTab(routePath) {
            const path = (routePath || '').toLowerCase()
            if (path === '/home') this.actIdx = 1
            else if (path === '/affiliate') this.actIdx = 3
            else if (path === '/vip') this.actIdx = 4
            else if (path.startsWith('/personbox')) this.actIdx = 5
            else this.actIdx = -1
        },
        toSports() {
            this.onNavTo({ url: 'Sports' })
        },
        change(idx) {
            if (this.actIdx === idx) return
            if (idx === 1) {
                this.onNavTo({ url: '/Home', replace: 1 })
                this.actIdx = idx
            } else if (idx === 2) {
                this.$store.dispatch('app/toggleSideBar')
            } else if (idx === 3) {
                this.onNavTo({ url: '/Affiliate', replace: 1 })
                this.actIdx = idx
            } else if (idx === 4) {
                this.onNavToByIsLogin({ url: '/vip', replace: 1 }).then((navigated) => {
                    if (navigated) this.actIdx = idx
                })
            } else if (idx === 5) {
                this.onNavToByIsLogin({ url: '/PersonBox', replace: 1 }).then((navigated) => {
                    if (navigated) this.actIdx = idx
                })
            }
        },
        onCloseSaveVersion() {
            this.isSaveVersionDesktop = false
        },
        onShowSaveVersionPopup() {
            this.isSaveVersionDesktop = false
            if (getPlatform() === 'ios') {
                this.$refs.pwaIosPopup.open()
            } else {
                this.$refs.SaveVersionPopup.open()
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/common/styles/viriables.scss';

html[data-device-nodesktop="1"] {
    .tabbar {
        display: none;
    }

    .tabbar-content {
        display: none;
    }
}

html[data-device-nodesktop="0"] {
    .tabbar {
        max-width: 100%;
    }

    .tabbar-content {
        max-width: 100%;
    }
}

.tabbar-content {
    position: relative;

    .pwa {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 101;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: .62rem;
        padding: 0 .26rem;
        background: var(--theme-tabbar-float-bg);
        border-top: 1px solid var(--theme-tabbar-divider);
        color: var(--theme-soft-text);
        font-size: .34rem;
        line-height: .34rem;
        box-shadow: 0 -.06rem .18rem rgba(0, 0, 0, .22);
    }
}

.tabbar {
    position: fixed;
    bottom: 0;
    z-index: 100;
    width: 100%;
    height: 1.24rem;
    margin: 0 auto;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: var(--theme-tabbar-shell-bg);

    .item {
        position: relative;
        width: 20%;
        height: 100%;
        overflow: visible;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-end;
        cursor: pointer;
        padding-top: .08rem;
        padding-bottom: .2rem;

        ::v-deep .van-icon {
            font-size: .48rem;
            color: var(--theme-tabbar-text);
            transition: color .2s ease;
        }
        .imgAct{
            display: none;
        }
        img {
            width: .64rem;
            height: .64rem;
            vertical-align: middle;
            filter: brightness(0) saturate(100%) invert(83%) sepia(19%) saturate(846%) hue-rotate(325deg) brightness(101%) contrast(91%);
        }

        .item-text {
            position: relative;
            z-index: 1;
            width: 100%;
            height: .24rem;
            margin-top: .08rem;
            line-height: .24rem;
            text-align: center;
            font-size: .24rem;
            color: var(--theme-tabbar-text);
            transition: color .2s ease;
        }

        &.act {
            background-image: var(--theme-tabbar-active-bg);
            background-size: var(--theme-tabbar-active-bg-size);
            background-position: var(--theme-tabbar-active-bg-position);
            background-repeat: no-repeat;
            ::v-deep .van-icon {
                color: var(--theme-tabbar-active-text);
                text-shadow: 0 0 .18rem var(--theme-soft-text);
            }

            .item-text {
                color: var(--theme-tabbar-active-text);
                text-shadow: 0 0 .18rem var(--theme-soft-text);
            }

            &.center {
                .center-img {
                    .center-inset {
                        border: 1px solid var(--theme-tabbar-divider);
                        background: var(--theme-gold-bg);
                    }
                }
            }
            & > img {
                display: none;

                &.imgAct{
                    display: block;
                    filter: brightness(0) invert(1);
                }
            }
        }

        &.center {
            .center-img {
                position: absolute;
                top: -.12rem;
                left: calc(50% - .6rem);
                width: 1.2rem;
                height: 1.2rem;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 50%;
                background: $bg-shell-subpanel-color;
                box-shadow: 0 -.08rem .18rem rgba($bg-shell-color, .24);

                .center-inset {
                    width: .95rem;
                    height: .95rem;
                    padding-bottom: .05rem;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border: 1px solid rgba($font-label-color, .38);
                    border-radius: 50%;
                    background: linear-gradient(180deg, rgba($font-label-color, .22) 0%, rgba($font-label-color, 0) .18rem), $bg-btn-color;
                }
            }
        }
    }
}
</style>
